'use client';

import { useEffect, useMemo } from 'react';
import config from 'config';
import {
  DASHBOARD_MOBILE_MEDIA_QUERY,
  getAreaIdByName,
  ROUTES
} from 'constant';
import { usePathname } from 'next/navigation';

import { Box, useMediaQuery } from '@chakra-ui/react';

import { useAppSelector } from 'store/hooks';

import { trackPathname } from 'utils';

import { AboveSiteBanner, StandardBanner } from 'components/Banners';
import { Menu } from 'components/Menu';
import { Tabs } from 'ui';
import { Header } from '../Header';

const {
  siteAlert: { areaIds }
} = config;

const AppMenu = () => {
  const pathname = usePathname();
  const { siteAlerts } = useAppSelector((state) => state.client);
  const { userInfo } = useAppSelector((state) => state.persistAuth);

  const isLogged = Boolean(userInfo?.clid) && Boolean(userInfo?.token);
  const areaId = useMemo(() => getAreaIdByName(areaIds, pathname), [pathname]);

  // AppMenu is mounted on every page, making it the single place to record
  // SPA route history (used e.g. by the profile screen's back arrow).
  useEffect(() => {
    trackPathname(pathname);
  }, [pathname]);

  const [isMobile] = useMediaQuery(DASHBOARD_MOBILE_MEDIA_QUERY, {
    fallback: false
  });

  const isAllowed =
    pathname.includes(ROUTES.dashboard) ||
    (isLogged && pathname === ROUTES.packagesShop);

  return (
    <>
      <AboveSiteBanner areaId={areaId} siteAlerts={siteAlerts} />
      <Header />
      {isAllowed && (
        <Box
          maxW='1330px'
          position='relative'
          px={{ base: 0, md: isMobile ? 0 : '25px' }}
          w='100%'
          mx='auto'
        >
          {isMobile ? <Menu /> : <Tabs />}
        </Box>
      )}

      <StandardBanner areaId={areaId} siteAlerts={siteAlerts} />
    </>
  );
};

export default AppMenu;
